import { displayDeckConfig } from "../constants";
import { utilImages } from "../Images";
import { deckData, CardDatum } from "./deckData";

export const displayDeck = ({
  deckConfig,
  excludedCardNames = [],
}: {
  deckConfig: string;
  excludedCardNames?: string[];
}): CardDatum => {
  switch (deckConfig) {
    case displayDeckConfig.SINGLE_CARD: {
      const available = excludedCardNames.length
        ? deckData.filter((c) => !excludedCardNames.includes(c.cardName))
        : deckData;
      const pool = available.length ? available : deckData;
      return pool[Math.floor(Math.random() * pool.length)];
    }
    default:
      return { image: utilImages.cardBack, cardName: '' };
  }
};
